import Loader from "@components/global/Loader/Loader";
import Button from "@components/global/new/Button/Button";
import Field from "@components/global/new/Field/Field";
import Title from "@components/global/new/Title/Title";
import WithModal, { CommonModalPropsI } from "@components/HOC/withModals";
import { MODALS_ENUM } from "@constants/Modals";
import { REACT_RECAPTCH_KEY } from "../../../../config";
import cn from "classnames";
import ReCAPTCHA from "react-google-recaptcha";
import styles from "./ForgotModal.module.scss";
import { useForgotModalControl } from "./useForgotModalControl";
import Error from "@components/global/new/Error/Error";

function ForgotModal(props: CommonModalPropsI) {
  const control = useForgotModalControl(props);

  return (
    <div className={styles.wrapper}>
      {control.isLoading && <Loader />}
      <Title>{props.formatMessage({ id: "modal.forgot.title" })}</Title>

      <form className={styles.content} onSubmit={control.onForgot}>
        <Field
          name={props.formatMessage({ id: "modal.forgot.email" })}
          type='email'
          placeholder='example@email.com'
          isError={!!control.errors}
          id={"email"}
        />
        {control.errors && <Error errors={control.errors} />}

        {REACT_RECAPTCH_KEY && (
          <div className={cn(styles.recaptcha, "g-recaptcha")}>
            <ReCAPTCHA
              sitekey={REACT_RECAPTCH_KEY}
              onChange={(response) =>
                response && control.setRecaptchaResponse(response)
              }
              onExpired={() => control.setRecaptchaResponse(undefined)}
              // size={control.isMob ? "compact" : "normal"}
              ref={control.reCapRef}
            />
          </div>
        )}

        <Button type='submit' disabled={!control.recaptcha}>
          {props.formatMessage({ id: "modal.forgot.send" })}
        </Button>
      </form>
    </div>
  );
}

export default WithModal(MODALS_ENUM.FORGOT, ForgotModal);
